import {
  Box,
  Typography,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  ThemeProvider,
  Paper,
  Zoom,
  IconButton,
} from "@mui/material";
import FingerprintIcon from "@mui/icons-material/Fingerprint";
import { useState } from "react";
import React from "react";
import { useForm, useWatch, Controller } from "react-hook-form";
import { Hero, QUESTIONS, Results } from "./constants";
import theme from "./theme";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

declare global {
  interface Window {
    storeTestResult: (result: string | null) => void;
  }
}

function mode<T = string>(arr: T[]) {
  return (
    arr
      .sort(
        (a, b) =>
          arr.filter((v) => v === a).length - arr.filter((v) => v === b).length
      )
      .pop() ?? null
  );
}
const absUrl = (path: string) => {
  return `https://papaya-axolotl-f33fd3.netlify.app/${path}`;
};
function App() {
  const [number, setNumber] = useState(0);
  const { control, handleSubmit, setValue } = useForm();
  const [result, setResult] = useState<Hero | null>(null);
  const answers = useWatch({ control, name: "answers" });
  const { options, text, icon } = QUESTIONS[number] ?? {};
 
  const pushAnswer = handleSubmit((data) => {
    if (!data.answers?.[number]) return;

    if (number === QUESTIONS.length - 1) {
      const result = mode<Hero>(data.answers);
      setResult(result);
    } else {
      setNumber(number + 1);
      setValue(`answers.${number + 1}`, "");
    }
  });
  
  return (
    <ThemeProvider theme={theme}>
      <Paper
        sx={{
          color: "#fff",
          backgroundColor: "primary.contrastText",
          borderColor: "primary.main",
          borderStyle: "solid",
          borderWidth: 2,
          p: 4,
          maxWidth: 720,
          minWidth: 600,
          margin: "auto",
          boxShadow:
            "rgba(163, 77, 136, 0.4) 5px 5px, " +
            "rgba(163, 77, 136, 0.3) 10px 10px, " +
            "rgba(163, 77, 136, 0.2) 15px 15px, " +
            "rgba(163, 77, 136, 0.1) 20px 20px, " +
            "rgba(163, 77, 136, 0.05) 25px 25px",
        }}
      >
        <form onSubmit={pushAnswer}>
          {text && !result && (
            <Box>
              <FormControl sx={{ width: "100%" }} variant="standard">
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: 600,
                    pb: 3,
                    textShadow: "1px 1px 5px rgb(163 77 136 / 52%)",
                    display: "flex",
                    alignItems: "center",
                    position: "relative",
                    pr: 5,
                  }}
                >
                  {icon && (
                    <Box
                      sx={{
                        maskImage: `url(${absUrl(`img/${icon}.png`)})`,
                        width: 50,
                        height: 50,
                        marginRight: 4,
                        backgroundColor: "white",
                        maskRepeat: "round",
                      }}
                    />
                  )}
                  {text}
                  <Box
                    sx={{
                      position: "absolute",
                      inset: "0 0 auto auto",
                    }}
                  >
                    <Zoom in={!!answers?.[number]}>
                      <IconButton color="primary" type="submit">
                        <ArrowForwardIcon sx={{ width: 42, height: 42 }} />
                      </IconButton>
                    </Zoom>
                  </Box>
                </Typography>
                <Controller
                  name={`answers.${number}`}
                  control={control}
                  render={({ field: { value, onChange } }) => {
                    return (
                      <RadioGroup
                        value={value}
                        onChange={onChange}
                        sx={{ paddingLeft: 6 }}
                      >
                        {options?.map((option) => (
                          <FormControlLabel
                            key={option.value}
                            {...option}
                            label={
                              <Typography variant="h6" sx={{ fontWeight: 100 }}>
                                {option.label}
                              </Typography>
                            }
                            sx={{
                              paddingY: 1,
                              color:
                                value !== option.value
                                  ? "primary.main"
                                  : "#fff",
                              display: "flex",
                              alignItems: "flex-start",
                              transition: "all 200ms",
                            }}
                            control={
                              <Radio
                                checkedIcon={
                                  <Zoom in={value === option.value}>
                                    <FingerprintIcon
                                      sx={{ width: 30, height: 30 }}
                                    />
                                  </Zoom>
                                }
                                icon={
                                  <FingerprintIcon
                                    sx={{ width: 30, height: 30 }}
                                  />
                                }
                                sx={{
                                  mt: -1,
                                  transition: "all 200ms",
                                  opacity: value !== option.value ? 0 : 1,
                                }}
                              />
                            }
                          />
                        ))}
                      </RadioGroup>
                    );
                  }}
                />
              </FormControl>
            </Box>
          )}
          {result ? (
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              flexDirection="column"
              gap={1}
            >
              <Typography variant="h2">{`Ты ${Results[result]}`}</Typography>
              <img src={absUrl(`/img/${result}.png`)} width={400} />
            </Box>
          ) : (
            <></>
          )}
        </form>
      </Paper>
    </ThemeProvider>
  );
}

export default App;
